export enum CheckoutPaymentWayFilter {
	Cash = 'Efectivo',
	Credit = 'Credit',
}

export enum CheckoutPaymentStatusFilter {
	Completed = 'REALIZADO',
}

export enum CheckoutPaymentKind {
	Cash = 'cash',
	Card = 'card',
}
